import React from 'react';
import { motion } from 'framer-motion';
import { AlertTriangleIcon, CalendarIcon, ClockIcon, RocketIcon } from 'lucide-react';
export function Urgency() {
  const scrollToForm = () => {
    document.getElementById('registro')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="w-full bg-red px-4 py-16 md:py-24" data-id="element-68">
      <motion.div initial={{
      opacity: 0,
      y: 40
    }} whileInView={{
      opacity: 1,
      y: 0
    }} viewport={{
      once: true
    }} transition={{
      duration: 0.7
    }} className="max-w-3xl mx-auto text-center" data-id="element-69">
        <AlertTriangleIcon className="w-12 h-12 text-white mx-auto mb-4" data-id="element-70" />
        <h2 className="font-oswald text-3xl md:text-5xl font-bold text-white uppercase mb-4" data-id="element-71">
          Los cupos son limitados
        </h2>
        <p className="text-white/80 font-inter text-base md:text-lg mb-8 max-w-lg mx-auto" data-id="element-72">
          Esta clase es completamente gratis pero los cupos se agotan rápido
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 mb-10" data-id="element-73">
          <div className="flex items-center gap-2" data-id="element-74">
            <CalendarIcon className="w-5 h-5 text-white" data-id="element-75" />
            <span className="font-oswald font-semibold text-white text-lg" data-id="element-76">
              Lunes 26 de Mayo 2026
            </span>
          </div>
          <div className="hidden sm:block w-px h-6 bg-white/30" data-id="element-77" />
          <div className="flex items-center gap-2" data-id="element-78">
            <ClockIcon className="w-5 h-5 text-white" data-id="element-79" />
            <span className="font-oswald font-semibold text-white text-lg" data-id="element-80">
              7:00 PM — Hora Colombia
            </span>
          </div>
        </div>

        <motion.button onClick={scrollToForm} whileHover={{
        scale: 1.03
      }} whileTap={{
        scale: 0.97
      }} className="inline-flex items-center gap-3 bg-white text-red font-oswald font-bold text-lg md:text-xl uppercase px-10 py-5 rounded-lg shadow-lg hover:bg-gray-100 transition-colors" data-id="element-81">
          <RocketIcon className="w-6 h-6" data-id="element-82" />
          RESERVAR MI LUGAR GRATIS!
        </motion.button>
      </motion.div>
    </section>;
}